import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, Input, OnInit } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { UiComponent } from '@df/ui/ui.component';
import { ProductDecorator } from '../../../../model/product/product.decorator';
import { ProductDeliveryPriceComponent } from '../../delivery/price/product-delivery-price.component';
import { ProductGeneralDetailsComponent } from '../../details/product-general-details.component';
import { ProductViewGiftBoxingComponent } from '../gift/boxing/product-view-gift-boxing.component';
import { IParentView } from '../layout/product-view-layout.abstract';
import { IProductViewLayoutContent } from '../layout/product-view-layout.interface';
import { ProductViewReviewsComponent } from '../reviews/product-view-reviews.component';

@Component({
    selector: 'product-view-summary',
    templateUrl: './product-view-summary.component.html',
    standalone: true,
    imports: [
        CommonModule,
        ProductDeliveryPriceComponent,
        ProductGeneralDetailsComponent,
        forwardRef(() => ProductViewGiftBoxingComponent),
        ProductViewReviewsComponent,
        SizeClassDirective,
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewSummaryComponent extends UiComponent implements OnInit {
    @Input({ required: true })
    product!: ProductDecorator<IProductDataV3>;

    @Input({ required: true })
    parentView!: IParentView;

    @Input({ required: true })
    parent!: ProductDecorator<IProductDataV3>;

    @Input({ required: true })
    content!: IProductViewLayoutContent;

    override ngOnInit() {
        this.subscriptions.add(this.parentView.detectChanges$.subscribe(() => this.detectChanges()));

        super.ngOnInit();
    }
}
